
import { MdFolder } from "react-icons/md"
import { AccessesCounter,  FilterCharDiv, Knowledge, KnowledgeList, KnowledgeTitle, Medias, MediasList, MediasTitle } from "./styles"

import { useEffect, useState } from "react"

import { CategoryIcon } from "./styles"
import { useTranslation } from "react-i18next"
import { Col, Row } from "react-bootstrap"
import { Skeleton } from "primereact/skeleton"
import { partnerDashboard } from "../../../../services/manager-dashboard.service"
import { DashboardCardChart } from "../../components/dashboard-card-chart"
import { DashboardFilterChart } from "../../components/dashboard-filter-chart"

interface IDashboardUsers {
    total: number;
    subscribers: number;
    visitors: number
}

interface IDashboardUsedMaterials {
    external_acesses: number;
    link_count: number;
    total: number;
}

interface IDashboardMostAccessedMedia {
    icon: string;
    category_title: string;
    hit_counter: string;
}

interface IDashboardMostAccessedKnowledge {
    knowledge_area: string;
    hit_counter: string;
}

export const ManagerPartnerDashboard = (): JSX.Element => {
    const { t: translation } = useTranslation()
    const [usedMaterials, setUsedMaterials] = useState<IDashboardUsedMaterials>()
    const [mostAccessedMedia, setMostAccessedMedia] = useState<IDashboardMostAccessedMedia[]>([])
    const [mostAccessedKnowledge, setMostAccessedKnowledge] = useState<IDashboardMostAccessedKnowledge[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        setIsLoading(true)
        partnerDashboard().then((res) => {
            setUsedMaterials(res.used_materials)
            setMostAccessedMedia(res.most_accessed_media_categories.sort((a: any, b: any) => {
                return b.hit_counter - a.hit_counter
            }))
            setMostAccessedKnowledge(res.most_accessed_knowledge.sort((a: any, b: any) => {
                return b.hit_counter - a.hit_counter
            }).slice(0, 4))
            setIsLoading(false)
        })
    }, [])


    return (
        <>
            <Row className="mb-5">
                <Col md={6} lg={3}  className="mb-4 mb-md-0 mb-xxl-0">
                    {isLoading && (
                        <Skeleton width="100%" height="100%" />
                    )}
                    {usedMaterials && !isLoading && (
                        <DashboardCardChart
                            labels={[translation('manager.dashboard.secondChart.firstLabel'), translation('manager.dashboard.secondChart.secondLabel')]}
                            datasets={{
                                data: [usedMaterials.external_acesses, usedMaterials.link_count],
                                backgroundColor: ['#FCD3A4', '#FFAF87'],
                                cutout: '70%',
                                total: usedMaterials.total,
                                fontSize: 29,
                            }}
                            linkText={translation('manager.dashboard.secondChart.link')}
                            linkTo="/manager/materials"
                            title={translation('manager.dashboard.secondChart.title')}
                            linkIcon={<MdFolder size={26} color={'#6473FF'} />}
                        />

                    )}
                </Col>

                <Col md={12} lg={9} >
                    {isLoading ? (
                        <Skeleton width="100%" height="250px" />
                    ) : (
                        <FilterCharDiv style={{ justifySelf: 'flex-end' }} >
                            <DashboardFilterChart  isPartner/>
                        </FilterCharDiv>
                    )}
                </Col>


                <Col md={12} lg={6} className="mb-4 mb-md-0 mb-xxl-0 mt-md-4">
                    {isLoading ? (
                        <Skeleton width="100%" height="250px" />
                    ) : (
                        <Knowledge>
                            <KnowledgeTitle>
                                <h1 style={{ fontSize: 20, color: '#333333', fontWeight: 700}}>{translation('manager.dashboard.knowledgeList.title')}</h1>
                            </KnowledgeTitle>
                            <KnowledgeList>
                                <ul>
                                    {mostAccessedKnowledge && mostAccessedKnowledge.map((knowledge) => (
                                        <li key={knowledge.knowledge_area}>
                                            <span>{knowledge.knowledge_area}</span>
                                            <AccessesCounter>{knowledge.hit_counter} {translation('manager.dashboard.objectsList.hits')}</AccessesCounter>
                                        </li>
                                    ))}

                                </ul>
                            </KnowledgeList>
                        </Knowledge>
                    )}

                </Col>
                <Col md={12} lg={6} className="mb-4 mb-md-0 mb-xxl-0 mt-md-4">
                    {isLoading ? (
                        <Skeleton width="100%" height="100%" />
                    ) : (
                        <Medias>
                            <MediasTitle>
                                <h1 style={{ fontSize: 20, color: '#333333', fontWeight: 700}}>{translation('manager.dashboard.objectsList.title')}</h1>
                            </MediasTitle>
                            <MediasList>
                                <ul>
                                    {!mostAccessedMedia.length && ( 
                                        <p>Nenhum objeto acessado ainda</p>
                                    )}
                                    {mostAccessedMedia && mostAccessedMedia.map((category) => (
                                        <li key={category.category_title}>
                                            <div>
                                                {category.icon ? (
                                                    <span><CategoryIcon className={`material-icons-${category.icon}`}>{category.icon.split(' ')[1]}</CategoryIcon></span>
                                                ) : (
                                                    <span><CategoryIcon className={`material-icons-outlined sticky_note_2`}>sticky_note_2</CategoryIcon></span>
                                                )}
                                                <span>{category.category_title}</span>
                                            </div>
                                            <AccessesCounter>{category.hit_counter} {translation('manager.dashboard.objectsList.hits')}</AccessesCounter>
                                        </li>

                                    ))}
                                </ul>
                            </MediasList>
                        </Medias>
                    )}
                </Col>


            </Row>
        </>
    )
}